<template>
  <div class="navbar-header-model">
    <!-- Desktop: todas as tabs em linha -->
    <div class="d-none d-lg-flex tabs-bella">
      <NuxtLink
        v-for="(tab, i) in tabsHeader"
        :key="`dt${i}`"
        :class="`${ tab.val == selectedTab ? 'active' : '' }`"
        :to="{
          name: `language-modelos-name-${tab.path}`,
          params: {
            name: route.params.name,
            language: route.params.language,
          },
        }"
      >
        <div class="tab-bella">{{ tab.name }}</div>
      </NuxtLink>
    </div>

    <!-- Mobile: tabs principais + Extras dropdown -->
    <div class="d-lg-none tabs-bella tabs-bella-mobile">
      <NuxtLink
        v-for="(tab, i) in mainTabs"
        :key="`mt${i}`"
        :class="`${ tab.val == selectedTab ? 'active' : '' }`"
        :to="{
          name: `language-modelos-name-${tab.path}`,
          params: {
            name: route.params.name,
            language: route.params.language,
          },
        }"
      >
        <div class="tab-bella">{{ tab.name }}</div>
      </NuxtLink>
      <div
        ref="extrasRef"
        class="extras-wrapper"
        :class="{ 'active': isExtraActive }"
        @click.stop="toggleExtras"
      >
        <div class="tab-bella">{{ translate.extras }}</div>
        <div v-if="showExtras" class="extras-dropdown">
          <NuxtLink
            v-for="(tab, i) in extraTabs"
            :key="`et${i}`"
            :class="`extras-item ${ tab.val == selectedTab ? 'active' : '' }`"
            :to="{
              name: `language-modelos-name-${tab.path}`,
              params: {
                name: route.params.name,
                language: route.params.language,
              },
            }"
            @click="closeExtras"
          >
            <div>{{ tab.name }}</div>
          </NuxtLink>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import translateModel from "@/tradutors/model";
import { abasDoEnsaio } from "@/utils/modelTabs";

const props = defineProps(["modelData", "modelInfo"]);

const route = useRoute();

const selectedTab = computed(() => validOptionNavbarUrlPainel());

const translate = computed(() =>
  route.params.language == "pt-br"
    ? translateModel.portugues
    : translateModel.ingles
);
const tabsHeader = computed(() => abasDoEnsaio(translate.value.navBar, props.modelData));
const mainTabs = computed(() => tabsHeader.value.filter((t: any) => [1, 2, 6, 7].includes(t.val)));
const extraTabs = computed(() => tabsHeader.value.filter((t: any) => [3, 4, 5].includes(t.val)));
const showExtras = ref(false);
const extrasRef = ref<HTMLElement | null>(null);
const isExtraActive = computed(() => [3, 4, 5].includes(selectedTab.value));

function toggleExtras() {
  showExtras.value = !showExtras.value;
}

function closeExtras() {
  showExtras.value = false;
}

function handleClickOutside(event: MouseEvent) {
  if (extrasRef.value && !extrasRef.value.contains(event.target as Node)) {
    showExtras.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

function validOptionNavbarUrlPainel() {
  switch (route.name) {
    case "language-modelos-name-photo":
      return 1;
    case "language-modelos-name-video":
      return 2;
    case "language-modelos-name-making-of":
      return 6;
    case "language-modelos-name-perfil":
      return 3;
    case "language-modelos-name-wallpaper":
      return 4;
    case "language-modelos-name-credits":
      return 5;
    case "language-modelos-name-live":
      return 7;
    default:
      return 1;
  }
}
</script>

<style scoped lang="css">
.tabs-bella {
  cursor: pointer;
  background-color: #f8f8f8;
  text-align: center;
}

.navbar-header-model >>> .tab-bella {
  height: 64px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 61px;
  top: 5px;
}

.navbar-header-model .tabs-bella > .active {
  border: 0px;
}

.navbar-header-model .tabs-bella > .active::after {
  content: "";
  background: #b20000;
  position: absolute;
  left: 25%;
  width: 50%;
  height: 3px;
  bottom: 0px;
}

.tabs-bella >>> .tab-bella {
  padding: 0px 35px;
}

.tabs-bella >>> .active .tab-bella {
  color: #b20000;
  border-color: #b20000;
  font-weight: bold;
  font-family: "Roboto-Bold";
}

.more-profile {
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.more-profile svg {
  color: #b20;
  margin-left: 8px;
}

:deep(.vl-icon) {
  transform: translate(0%, -500%);
}

/* Extras dropdown */
.tabs-bella-mobile {
  display: flex;
  align-items: center;
  width: 100%;
}

.tabs-bella-mobile > a,
.tabs-bella-mobile > .extras-wrapper {
  flex: 1;
  text-align: center;
}

.extras-wrapper {
  position: relative;
  cursor: pointer;
}

.extras-wrapper.active::after {
  content: "";
  background: #b20000;
  position: absolute;
  left: 0%;
  width: 100%;
  height: 3px;
  bottom: 0px;
}

.extras-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  background: #f8f8f8;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 100;
  min-width: 100px;
  padding: 8px 0;
}

.extras-item {
  display: block;
  padding: 5px 0px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.extras-item:hover {
  background-color: #f8f8f8;
}

.extras-item.active {
  color: #b20000;
  font-weight: bold;
  font-family: "Roboto-Bold";
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .tabs-bella >>> .tab-bella {
    padding: 0px 5px;
  }

  .navbar-header-model >>> .tab-bella {
    font-size: 13px !important;
  }

  .tabs-bella {
    margin-left: 0px;
  }

  :deep(.icon-arrow-ios-left::before) {
    background-color: #000000;
  }

  .navbar-header-model .tabs-bella > .active::after {
    left: 25%;
    width: 50%;
    height: 3px;
    bottom: 16px;
  }

  .extras-wrapper.active::after {
    bottom: 16px;
  }
}
</style>
